function withRelativePath(file: File, relativePath: string): File {
  if (file.webkitRelativePath === relativePath) return file;
  Object.defineProperty(file, 'webkitRelativePath', {
    configurable: true,
    value: relativePath,
  });
  return file;
}

async function readDirectoryEntries(entry: FileSystemDirectoryEntry): Promise<FileSystemEntry[]> {
  const reader = entry.createReader();
  const entries: FileSystemEntry[] = [];
  while (true) {
    const batch = await new Promise<FileSystemEntry[]>((resolve, reject) => reader.readEntries(resolve, reject));
    if (!batch.length) return entries;
    entries.push(...batch);
  }
}

async function readEntry(entry: FileSystemEntry, parentPath = ''): Promise<File[]> {
  const relativePath = parentPath ? `${parentPath}/${entry.name}` : entry.name;
  if (entry.isFile) {
    const fileEntry = entry as FileSystemFileEntry;
    const file = await new Promise<File>((resolve, reject) => fileEntry.file(resolve, reject));
    return [withRelativePath(file, relativePath)];
  }
  if (!entry.isDirectory) return [];
  const children = await readDirectoryEntries(entry as FileSystemDirectoryEntry);
  return (await Promise.all(children.map((child) => readEntry(child, relativePath)))).flat();
}

export async function filesFromDrop(dataTransfer: DataTransfer): Promise<File[]> {
  const items = Array.from(dataTransfer.items ?? []);
  const entries = items.map((item) => item.webkitGetAsEntry()).filter((entry): entry is FileSystemEntry => Boolean(entry));
  if (entries.length) return (await Promise.all(entries.map((entry) => readEntry(entry)))).flat();
  return Array.from(dataTransfer.files ?? []);
}
